const state = {
    user_logged: false,
    email: null,
    user_data: null,
    access_token: null,
};

const mutations = {
    SET_ADMIN_INFO(state, { email, user_data, access_token }) {
        state.user_logged = true;
        state.email = email;
        state.user_data = user_data;
        state.access_token = access_token;
    },
    ERASE_ADMIN_INFO(state) {
        state.user_logged = false;
        state.email = null;
        state.user_data = null;
        state.access_token = null;
    },
};

const getters = {
    get_admin_data(state) {
        return state;
    },
};

const actions = {
    async login({ commit }, { email, password }) {
        const { ct_admins } = await import('@/controllers/admins');

        const response = await ct_admins.signIn({ email, password });
        if (!response.status) throw response.error;

        // o signin devolve só o token; o perfil vem numa segunda chamada
        const profile = await ct_admins.getProfile(response.access_token);

        commit('SET_ADMIN_INFO', {
            email,
            user_data: profile.status ? profile.data : null,
            access_token: response.access_token,
        });
    },

    logout({ commit }) {
        commit('ERASE_ADMIN_INFO');
        commit('admins_dashboard/RESET_ADMIN_DASHBOARD_STATE', null, { root: true });
        commit('admins_tenants/RESET_ADMIN_TENANTS_STATE', null, { root: true });
    },
};

const admins_users = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};

export default admins_users;
